import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaseStudyFormStepperComponent } from './case-study-form-stepper.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [CaseStudyFormStepperComponent],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [CaseStudyFormStepperComponent]
})
export class CaseStudyFormStepperModule { }
